import React, { useContext, useEffect, useState } from "react";
import { getMosqueOrders } from "../../utils/zulalWebAPI";
import { UserContext } from "../../context/user.context";
import { UilSync } from "@iconscout/react-unicons";
import generateSecretKey from "../../utils/keyGenerationUtils";
import { encryptDataBase64 } from "../../utils/encryptionUtils";

export const MosqueOrders = () => {
  const { currentUser } = useContext(UserContext);
  const [ordersHistory, setOrdersHistory] = useState([]);
  const [show, setShow] = useState(false);
  const [currentFile, setCurrentFile] = useState(null);

  // get customer orders from Zulal Web API
  const LoadData = async () => {
    try {
      const customerCode = currentUser.customerCode;
      const secretKey = generateSecretKey();
      const encryptedCustomerInfo = encryptDataBase64(customerCode, secretKey);

      const encryptedData = {
        secretKey: secretKey,
        encrypteCustomerInfo: encryptedCustomerInfo,
      };

      const response = await getMosqueOrders(encryptedData);
      setOrdersHistory(response);
    } catch (error) {
      console.error("Error fetching orders: ", error.message);
    }
  };

  useEffect(() => {
    LoadData();
    // eslint-disable-next-line
  }, []);

  const handleShow = (filePath) => {
    setCurrentFile(filePath);
    setShow(true);
  };
  const handleClose = () => {
    setShow(false);
    setCurrentFile(null);
  };

  function formatOrderNumber(orderNumber) {
    console.log(orderNumber.length);
    if (orderNumber.length == 36) {
      console.log("condition met");
      console.log(orderNumber.slice(-6));
      return orderNumber.slice(-6).toUpperCase();
    }
    return orderNumber;
  }

  const getFileExtension = (filePath) => {
    if (!filePath) return null;
    return filePath.split(".").pop().toLowerCase();
  };

  const renderFileContent = (filePath) => {
    if (!filePath)
      return <div className="text-gray-400">No attachment found.</div>;
    const ext = getFileExtension(filePath);
    if (["jpg", "jpeg", "png", "gif"].includes(ext)) {
      return (
        <img src={filePath} alt="attachment" className="mx-auto max-h-96" />
      );
    }
    if (ext === "pdf") {
      return (
        <div className="p-4 bg-primaryVeryLight rounded-xl shadow-lg">
          <iframe
            src={filePath}
            title="PDF Attachment"
            className="w-full h-[80vh] border border-gray-300 rounded-lg"
          />
        </div>
      );
    }
    return (
      <a
        href={filePath}
        target="_blank"
        rel="noopener noreferrer"
        className="text-blue-500 underline"
      >
        Download Attachment
      </a>
    );
  };

  // Helper to build full file URL
  const getAttachmentUrl = (filePath) =>
    filePath ? `${process.env.REACT_APP_ATTACHMENTPATH + filePath}` : null;

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="sm:flex sm:items-center">
        <div className="text-navarbarText text-3xl font-poppins font-medium mb-8">
          Orders
          <p className="text-base text-darkTextColor font-poppins font-normal">
            Last 6 Months orders with details and status.
          </p>
        </div>
        <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
          <button
            className="flex rounded-md bg-secondary h-10 w-10 items-center justify-center text-center"
            onClick={LoadData}
          >
            <UilSync className="w-6 text-textWhite" />
          </button>
        </div>
      </div>

      <div className="-mx-4 mt-8 sm:-mx-0">
        <table className="min-w-full divide-y divide-gray-300">
          <thead>
            <tr>
              <th className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0">
                Order #
              </th>
              <th className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:table-cell">
                Order Date
              </th>
              <th className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:table-cell">
                Masjid Code
              </th>
              <th className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 lg:table-cell">
                Total
              </th>
              <th className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 lg:table-cell">
                Status
              </th>
              <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                View Doc
              </th>
              <th className="relative py-3.5 pl-3 pr-4 sm:pr-0">
                <span className="sr-only">Details</span>
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 bg-white">
            {ordersHistory && ordersHistory.length > 0 ? (
              ordersHistory.map((item) => {
                const attachmentUrl = getAttachmentUrl(item.filePath);
                return (
                  <tr key={item.Id}>
                    <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0">
                      {formatOrderNumber(item.OrderId)}
                    </td>
                    <td className="hidden whitespace-nowrap px-3 py-4 text-sm text-gray-500 sm:table-cell">
                      {item.createdDate}
                    </td>
                    <td className="hidden whitespace-nowrap px-3 py-4 text-sm text-gray-500 sm:table-cell">
                      {item.MasjidCode}
                    </td>
                    <td className="hidden whitespace-nowrap px-3 py-4 text-sm text-gray-500 lg:table-cell">
                      {item.Amount &&
                        item.Amount.toLocaleString("en-ae", {
                          style: "currency",
                          currency: "AED",
                          minimumFractionDigits: 2,
                        })}
                    </td>
                    <td className="hidden whitespace-nowrap px-3 py-4 text-sm text-gray-500 lg:table-cell">
                      {item.Status}
                    </td>
                    <td className="whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
                      {attachmentUrl ? (
                        <button
                          className="px-3 py-1 bg-blue-600 text-cool-gray-500 rounded hover:bg-blue-700"
                          onClick={() => handleShow(attachmentUrl)}
                        >
                          View Attachment
                        </button>
                      ) : (
                        <button
                          className="px-3 py-1 bg-gray-300 text-gray-600 rounded cursor-not-allowed"
                          disabled
                        >
                          Waiting for delivery
                        </button>
                      )}
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={7} className="text-center py-8 text-gray-500">
                  No Orders to Display
                </td>
              </tr>
            )}
          </tbody>
        </table>

        {show && (
          <div className="fixed inset-0 z-50 bg-cool-gray-600 bg-opacity-50 flex items-center justify-center">
            <div className="bg-textWhite rounded-xl shadow-2xl w-[90%] max-w-4xl overflow-hidden">
              {/* Header */}
              <div className="flex items-center justify-between px-4 py-2 bg-cool-gray-200 border-b">
                <h2 className="text-lg font-semibold">Attachment Viewer</h2>
                <button
                  onClick={handleClose}
                  className="text-gray-500 hover:text-red-600 transition"
                >
                  ✕
                </button>
              </div>

              {/* Iframe */}

              <div>{renderFileContent(currentFile)}</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
